import { render, staticRenderFns } from "./AllergensAndAdditivesForm.vue?vue&type=template&id=31a283a1"
import script from "./AllergensAndAdditivesForm.vue?vue&type=script&lang=ts"
export * from "./AllergensAndAdditivesForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports